<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">Contacts</span>
      <div class="d-flex">
        <a-button size="large" class="a-header--button slide-down-enter-active mr-3" @click="onBulkEdit">
          <a-icon type="edit" theme="filled" />
          Bulk Edit
        </a-button>
        <a-button size="large" class="a-header--button slide-down-enter-active" type="primary" @click="onAdd">
          <img class="mr-2 icon-size" src="@assets/icon/plus.svg" />
          Add New
        </a-button>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <transition name="slide-up">
      <div class="a-filter" v-if="!isLoading">
        <a-row class="full-w" type="flex" justify="start" :gutter="16">
          <a-col :span="5">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input class="custom-prefix" placeholder="Search Contact Name" @change="onSearch"></a-input>
            </div>
          </a-col>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :pagination="pagin"
            :columns="ContactListColumn"
            :dataSource="filterData"
            :tableSize="tableSize">
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item @click="onEdit(record)"> <a-icon type="edit"></a-icon>Edit </a-menu-item>
                  <a-menu-item>
                    <div class="full-wh" @click="showDeleteConfirm(record)"><img class="mr-2" src="@assets/icon/delete.svg" /> Delete</div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import ContactService from '../services/contact.service';
  import { ContactListColumn } from '../columnsTable/ContactListColumn';
  import ContactGroupService from '@modules/ContactGroup/services/contact-group.service';

  export default {
    name: 'ContactList',
    data() {
      let pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        PAGE_OPTIONS,
        ContactListColumn,
        data: [],
        filterData: [],
        contactGroups: [],
        filterParams: {
          search: ''
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: ''
        }
      };
    },
    mounted() {
      this.getContactGroupList().then((data) => {
        this.getList(data);
      });
    },
    methods: {
      filter() {
        const searchTerm = this.filterParams.search.trim().toLowerCase();
        this.filterData = searchTerm ? this.data.filter((item) => item.name.toLowerCase().includes(searchTerm)) : this.data;
        this.pagin = {
          current: 1,
          pageSize: this.pagin.pageSize,
          total: this.filterData.length
        };
      },
      onAdd() {
        this.$router.push('/contact/add');
      },
      onBulkEdit() {
        this.$router.push('/contact/bulk-edit');
      },
      onDelete(record) {
        ContactService.delete(record.id).then(() => {
          this.$showSuccessMessage('Deleted Contact');
          this.getList();
        });
      },
      onEdit(record) {
        this.$router.push({
          path: '/contact/' + record.id
        });
      },
      onSearch(event) {
        this.filterParams.search = event.target.value;
        this.filter();
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      async getList(contactGroups = this.contactGroups) {
        try {
          const data = await ContactService.getList();
          this.data = [...(data || [])].map((item, index) => {
            item.index = index + 1;
            item.sms = item.sms && `(+65) ${item.sms}`;
            const contactGroup = contactGroups.find((g) => g.id === item.contact_group_id);
            item.contact_group = contactGroup && contactGroup.description;
            return item;
          });
          this.filter();
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      getContactGroupList() {
        return ContactGroupService.getList().then((data) => {
          this.contactGroups = data;
          return data;
        });
      },
      showDeleteConfirm(record) {
        this.$confirm({
          title: 'Are you sure delete this item?',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.onDelete(record);
          }
        });
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>

<style></style>
